import { createContext, useContext } from 'react';

import type { ElectoralCodeLevel } from '../helper';

export interface CodePeekEntry {
	level: ElectoralCodeLevel;
	code: string;
}

export interface CodePeekValue {
	current: CodePeekEntry | null;
	history: CodePeekEntry[];
	openPeek: (level: ElectoralCodeLevel, code: string) => void;
	closePeek: () => void;
	goToHistory: (index: number) => void;
	promoteToPrimary: () => void;
}

export const CodePeekContext = createContext<CodePeekValue | null>(null);

export const useCodePeek = (): CodePeekValue | null => useContext(CodePeekContext);
